import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { SettingsComponent } from './settings/settings.component';
import { AuthGuard } from './providers/auth.guard';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BoardComponent } from './board/board.component';
import { TrendsComponent } from './trends/trends.component';
import { Last5Component } from './last5/last5.component';
import { ManagerComponent } from './manager/manager.component';
import { HomeComponent } from './home/home.component';

const routes: Routes = [
  // { path: '', redirectTo: '', pathMatch: 'full' },
  { path: 'SignIn', component: SigninComponent },
  {
    path: 'SignUp',
    component: SignupComponent
  },
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'Settings',
    component: SettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'DashBoard',
    component: DashboardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'Board',
    component: BoardComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'Trends',
    component: TrendsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'Last5',
    component: Last5Component,
    canActivate: [AuthGuard]
  },
  {
    path: 'Manager',
    component: ManagerComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
